module.exports = __webpack_public_path__ + "static/media/white-paint.2c3e4b5d.jpg";